import { render, staticRenderFns } from "./AdminAddAnnouncementModal.vue?vue&type=template&id=5a125e07"
import script from "./AdminAddAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AdminAddAnnouncementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports